<template>
  <div class="container-fluid">
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col ml-n2">
                <h4 class="mb-1">
                  <a
                    >{{ $t('Sales payment') }} <strong> #{{ item.code }}</strong></a
                  >
                </h4>
              </div>
              <div class="col-auto">
                <router-link
                  :to="path + '/' + item.id + '/edit'"
                  class="btn btn-sm btn-primary"
                  :title="$t('Modification')"
                >
                  <i class="fas fa-edit"></i>
                </router-link>
                <a @click="print(item.id)" class="btn btn-sm btn-primary" :title="$t('Printing')">
                  <i class="fas fa-print"></i>
                </a>
                <a
                  :href="$linkGenerator('/salespayments/' + item.id + '/pdf')"
                  download
                  class="btn btn-sm btn-primary"
                  :title="$t('Download pdf')"
                >
                  <i class="fas fa-download"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-8">
        <div class="card card-body p-5 invoice-show">
          <SalesPaymentComponent :item="item" />
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">#{{ item.code }}</h4>
          </div>
          <div class="card-body">
            <ul class="list-unstyled">
              <li>
                <strong>{{ $t('Created in') }}</strong> :
                {{ item.created_at }}
              </li>
              <li>
                <strong>{{ $t('Last update') }}</strong> :
                {{ item.updated_at }}
              </li>
              <li v-if="item.client_type == 0">
                <strong>{{ $t('Client') }}</strong> :
                <router-link :to="'/customers/' + item.customer.id">
                  {{ item.customer.name }}</router-link
                >
              </li>
              <li v-if="item.client_type == 1">
                <strong>{{ $t('Client') }}</strong> :
                <router-link :to="'/suppliers/' + item.supplier.id">
                  {{ item.supplier.name }}</router-link
                >
              </li>
              <li>
                <strong>{{ $t('Administrator') }}</strong> :
                {{ item.user.name }}
              </li>
            </ul>
          </div>
        </div>

        <showFile />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import showFile from '@/elements/show/showFile.vue'
import SalesPaymentComponent from '@/print/components/salesPayments.vue'
export default {
  data() {
    return {
      path: '/salesPayments',
      item: {},
      printInvoice: false
    }
  },
  mounted() {
    this.getitem()
  },
  methods: {
    getitem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
      })
    },
    print(id) {
      this.$parent.printedSalesPayment = this.item
    }
  },
  components: {
    showFile,
    SalesPaymentComponent
  }
}
</script>
